import { createEffect, createStore } from 'effector';
import api, { AccessToken, RefreshToken } from '../Auth/api';
export const $userSearch = createStore([]);

export const searchUserFx = createEffect(
    async (query) => {
        if (!query) return;
        const response = await api.post(`/user/search`, { query });
        return response;
    }
);
$userSearch.on(searchUserFx, (_) => {
    return [];
});
$userSearch.on(searchUserFx.done, (_, { result }) => {
    if (result?.data?.data) {
        return [...result.data.data];
    }
});

$userSearch.on(searchUserFx.fail, () => {
    return [];
});